// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__bGrOe","summary":"CartItem_summary__k6B+6","price":"CartItem_price__sQcxA","amount":"CartItem_amount__jFjP-","actions":"CartItem_actions__EG935"};